import { render, staticRenderFns } from "./relevance-relation.vue?vue&type=template&id=2c29c8e8"
import script from "./relevance-relation.vue?vue&type=script&lang=ts"
export * from "./relevance-relation.vue?vue&type=script&lang=ts"
import style0 from "./relevance-relation.vue?vue&type=style&index=0&id=2c29c8e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports